const ipv4 = "https://sentry-backend-app-ay75l.ondigitalocean.app"
var reload =0;

export { ipv4 ,reload};